import { render, staticRenderFns } from "./AtsConnectModal.html?vue&type=template&id=c1d2a130&scoped=true&external"
import script from "./AtsConnectModal.js?vue&type=script&lang=js&external"
export * from "./AtsConnectModal.js?vue&type=script&lang=js&external"
import style0 from "./AtsConnectModal.scss?vue&type=style&index=0&id=c1d2a130&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d2a130",
  null
  
)

export default component.exports